import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import PreviewBanner from "./PreviewBanner";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <PreviewBanner />
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
